import { Fragment, useState } from "react";
import { Transition } from "@headlessui/react";
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from "@heroicons/react/24/solid";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";
import WithNotification from "./WithNotification";
import { General } from "../../common/constants";

const PellerexNotification = (props) => {
  const [show, setShow] = useState(false);

  const closeNotification = ({ id }) => {
    props.deNotify({
      id,
    });
  };

  useEffect(() => {
    setShow(props.visible);
  }, [props.visible, props.message]);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        closeNotification({ id: props.id });
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [show, props.id]);

  // Get notification styles based on type
  const getNotificationStyles = () => {
    switch (props.type) {
      case General.Notification.Types.Success:
        return {
          iconColor: 'text-notification-success',
          Icon: CheckCircleIcon,
        };
      case General.Notification.Types.Error:
        return {
          iconColor: 'text-notification-error',
          Icon: ExclamationCircleIcon,
        };
      case General.Notification.Types.Warning:
        return {
          iconColor: 'text-notification-warning',
          Icon: ExclamationTriangleIcon,
        };
      default:
        return {
          iconColor: 'text-notification-info',
          Icon: InformationCircleIcon,
        };
    }
  };

  const styles = getNotificationStyles();
  const IconComponent = styles.Icon;

  return (
    <>
      {show && (
        <div
          aria-live="assertive"
          className="flex items-end pointer-events-none sm:items-start"
        >
          <div className="flex w-full flex-col items-center sm:items-end">
            <Transition
              show={show}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="pointer-events-auto w-80 overflow-hidden rounded-xl bg-surface shadow-xl ring-1 ring-border">
                <div className="p-4">
                  <div className="flex items-start gap-3">
                    <div className="shrink-0">
                      <IconComponent
                        className={`h-5 w-5 ${styles.iconColor}`}
                        aria-hidden="true"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-foreground m-0">
                        {props.title}
                      </p>
                      <p className="mt-1 text-sm text-foreground-secondary mb-0 leading-relaxed">
                        {props.message}
                      </p>
                    </div>
                    <div className="shrink-0 -mt-1 -mr-1">
                      <button
                        type="button"
                        className="inline-flex p-1 rounded-lg text-foreground-subtle hover:text-foreground-secondary hover:bg-surface-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all"
                        onClick={() => {
                          closeNotification({ id: props.id });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      )}
    </>
  );
};

export default WithNotification(PellerexNotification);
